import React, { useEffect, useState, createContext, useMemo } from 'react';
import { useTimesheetOffline } from '../../../utils/useTimesheetOffline';
import TimesheetOfflineBanner from '../../common/TimesheetOfflineBanner';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Slider } from '@mui/material';
import dayjs from 'dayjs';
// eslint-disable-next-line import/no-cycle
import { TimesheetsHeader, MainTable, TotalSection, Attachments } from './index';
import { useBlocker, usePrevious, useWindowSize } from '../../../utils/hooks';
import { appNotificationsTypes, months, responsiveSizeTimesheet, timesheetsStatuses } from '../../../utils/constants';
import NavigationComponent from '../../common/NavigationComponent/NavigationComponent';
import axiosClient, { tneAxiosClient } from '../../../api/apiSettings';
import BaseModal from '../../common/ModalWindows/BaseModal';
import WithCloseIcon from '../../common/ComposableWrappers/WithCloseIcon/WithCloseIcon';
import {
  addNewSection,
  addNewTimesheet,
  changeStatus,
  deleteLineById,
  deleteRejectionComment,
  deleteSection,
  getTimesheet,
  restoreDeletedTimesheetLine,
  saveComment,
  setSaveSuccess,
  setSelectedSectionData,
  setSubmitSuccess,
  updateComment
} from '../../../actions/timesheet';
import { getListOfApprovers } from '../../../actions/user';
import NotificationModal from '../../common/ModalWindows/NotificationModal';
import ApproverComment from './ApproverComment/ApproverComment';
import {
  RejectModal,
  CopyModal,
  FinalModal,
  UnsavedChanges,
  DeletePopUp,
  PlacementModal,
  WithdrawModal,
  TimeandExpensePopup,
  SubmitModal,
  AttachmentModal
} from '../../common/ModalWindows/TNEModals/index';
import { basicErrorHandler, getSerializedSearchParams } from '../../../utils/helpers';
import classes from './Timesheet.module.scss';
import MobileHeadMenu from './components/MobileHeadMenu/MobileHeadMenu';
// eslint-disable-next-line import/no-cycle
import TimeandExpenseActions from '../../common/buttons/TimeandExpenseActions/TimeandExpenseActions';
import { generalEnums, idTokenClaims, rateEnum, submissionEnum } from '../../../utils/enums';
import colors from '../../../scss/colors';
import ExpandIcon from '../../common/Icons/ExpandIcon';
import { removeNotification, setNotification } from '../../../actions/appNotifications';
import { deleteTimesheet } from '../../../actions/timesheets';
import TimesheetTableWrapper from './MainTable/TimesheetTableWrapper/TimesheetTableWrapper';
import { RequestNewApprover, SubmittedSuccessfull } from '../../common/ModalWindows/TNEModals/SubmitModal/SubmitModal';
import { add } from 'lodash';
import { useMsal } from '@azure/msal-react';
import DailyTotalSection from './MainTable/DailyTotalSection/DailyTotalSection';
import DailyTotalHeatStrip from './MainTable/DailyTotalHeatStrip/DailyTotalHeatStrip';

export const EditContext = createContext(null);

const FakeArrow = ({ direction }) => {
  return (
    <div className={`${classes.fakeArrow} ${direction === 'left' ? classes.left : classes.right}`}>
      <div className={classes.inner} />
    </div>
  );
};

const baseWorkTypes = [
  { label: 'Straight Time', value: 1, key: 1 },
  { label: 'Overtime', value: 2, key: 2 },
  { label: 'PTO', value: 5, key: 5 }
];

export default function Timesheet() {
  const size = useWindowSize();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const timesheet = useSelector((state) => state.timesheet.data);
  const isTimesheetSaveSuccess = useSelector((state) => state.timesheet.saveSuccess);
  const isTimesheetSubmitSuccess = useSelector((state) => state.timesheet.submitSuccess);
  const selectedSectionData = useSelector((state) => state.timesheet.selectedSectionData);
  const workTypes = useSelector((state) => state.constFromApi.worktypes);
  const isApprover = useSelector((state) => state.accessToParts.tAndEApprover);
  const approvers = useSelector((state) => state.user.approvers);
  const commentsaving = useSelector((state) => state.timesheet.commentPending);
  const deletePending = useSelector((state) => state.timesheets.pendingDelete);
  const timesheetPlacementStatus = useSelector((state) => state?.timesheet?.validate?.timesheet.IsValidPlacementStatus);
  const isOnline = useSelector((state) => state.pwa.isOnline);
  const offlineQueueCount = useSelector((state) => state.timesheetOffline.offlineQueueCount);


  const prevPendingDelete = usePrevious(deletePending);
  const previousTimesheet = usePrevious(timesheet);
  const [submissionType, setSubmissionType] = useState(null);
  const [isSplitApprovalFlow, setIsSplitApprovalFlow] = useState(null);
  const [rateType, setRateType] = useState(rateEnum.HOURLY);
  const [startDateOfPeriod, setStartDateOfPeriod] = useState(false);
  const [isEdit, setIsEdit] = useState(size.width < responsiveSizeTimesheet);
  const [hasChanges, setHasChanges] = useState(false);
  const [saving, setSavaing] = useState(false);
  const [approving, setApproving] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [withdrawing, setWithdrawing] = useState(false);
  const [lineToDelete, setLineToDelete] = useState('');
  const [commentToDelete, setCommentToDelete] = useState(null);
  const [openPopUp, setOpenPop] = useState(false);
  const [error, setError] = useState('');
  const [scroll, setScroll] = useState(0);
  const [created, setCreated] = useState(false);
  const [scrollableRef, setScrollableRef] = useState(null);
  const [scrollablePerDiem, setScrollablePerDiem] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [sectionToDelete, setSectionToDelete] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  const [dirtySectionIds, setDirtySectionIds] = useState([]);
  const { accounts } = useMsal();

  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const locationQueryParams = useLocation();

  const { saveDraftOffline, queueSubmission, loadDraft, clearDraft } = useTimesheetOffline(timesheet);

  const claims = accounts[0]?.idTokenClaims;
  const isApproverAccount = claims && claims[idTokenClaims.IS_TNE_APPROVER]

  useBlocker(() => setOpenPop('unsavedChanges'), hasChanges);

  const markSectionDirty = (sectionId) => {
    if (!sectionId) return;
    setDirtySectionIds((prev) => prev.includes(sectionId) ? prev : [...prev, sectionId]);
  }

  const isTimesheetValid = (isSplitFlow) => {

    const allDetails = isSplitFlow
      ? timesheet?.TimesheetSections?.flatMap((section) => section.TimesheetDetails || []) || []
      : timesheet?.TimesheetDetails || [];

    if (allDetails.length === 0) return true;

    const timehseetsHoursLength = allDetails[0].TimesheetHoursByDates?.length || 0;

    for (let i = 0; i < timehseetsHoursLength; i++) {
      let sumOfHours = 0;
      for (let j = 0; j < allDetails.length; j++) {
        sumOfHours += Number(allDetails[j].TimesheetHoursByDates[i]?.TotalHrs || 0);
      }

      const isOverLimit = (rateType === rateEnum.DAILY && sumOfHours > 1) ||
        (rateType === rateEnum.HOURLY && sumOfHours > 24);
      if (isOverLimit) {
        setError(
          rateType === rateEnum.DAILY
            ? t('dashboard.createtimesheet.steps.max1day')
            : t('dashboard.createtimesheet.steps.max24h')
        );
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (isTimesheetSaveSuccess) setOpenPop('saved');
  }, [isTimesheetSaveSuccess]);

  const saveHandler = async (withPopUp = true) => {
    const isSplitFlow = timesheet?.IsSplitApprovalFlow || false;

    if (
      (submissionType === submissionEnum.MONTHLY ||
        submissionType === submissionEnum.BI_MONTHLY ||
        submissionType === submissionEnum.BI_WEEKLY) &&
      [
        timesheetsStatuses(t).processed.apiStatus,
        timesheetsStatuses(t).approved.apiStatus
      ].includes(timesheet.Status.Status)
    ) {
      return;
    }

    if (!isTimesheetValid(isSplitFlow)) return;

    const detailsToValidate = isSplitFlow
      ? timesheet.TimesheetSections.flatMap((section) => section.TimesheetDetails)
      : timesheet.TimesheetDetails;

    if (!detailsToValidate.every((item) => item.Location)) {
      setError(t('dashboard.timesheet.validations.location'));
      return;
    }

    if (isSplitFlow) {
      const hasDuplicateApproverId = (items) => {
        const ids = items.map((i) => i.ApproverId);
        return ids.length !== new Set(ids).size;
      };

      if (hasDuplicateApproverId(timesheet.TimesheetSections)) {
        setError(t('dashboard.timesheet.validations.duplicateApprover'));
        return;
      }
    }

    // ✅ ALWAYS save to IndexedDB first (works online and offline)
    await saveDraftOffline(timesheet);

    // ✅ OFFLINE: Stop here, show notification if withPopUp
    if (!isOnline) {
      if (withPopUp) {
        dispatch(
          setNotification({
            isAppStyled: true,
            message: 'Draft saved locally - will sync when back online',
            duration: 4000,
            type: appNotificationsTypes.SUCCESS,
            bottom: '147px'
          })
        );
      }
      return;
    }

    // ✅ ONLINE: Continue with normal server save
    if (withPopUp) setSavaing(true);

    try {
      if (withPopUp) setHasChanges(false);

      if (isSplitFlow) {
        const formData = new FormData();

        const payload = {
          UserId: timesheet.UserId,
          TimesheetId: timesheet.Id,
          TimesheetSections: timesheet.TimesheetSections
            .filter((section) => {
              const status = section.Id
                ? section?.Status?.Status
                : timesheetsStatuses(t).draft.apiStatus;
              return (
                status !== timesheetsStatuses(t).approved.apiStatus &&
                status !== timesheetsStatuses(t).processed.apiStatus
              );
            })
            .map((section) => {
              const attachmentIndices = timesheet?.GlobalFiles?.map(
                (fileObj, index) => (fileObj.SectionId === section.Id ? index : -1)
              ).filter((index) => index !== -1);
              const wasModified = dirtySectionIds.includes(section.Id);
              const isNewSection = typeof section.Id === 'string';

              return {
                ApproverId: section.ApproverId,
                Approver: section.Approver,
                ...(typeof section.Id !== 'string' ? { Id: section.Id } : {}),
                SectionStatus:
                  wasModified || isNewSection
                    ? timesheetsStatuses(t).draft.apiStatus
                    : section.Status.Status,
                TimesheetDetails: section.TimesheetDetails.map((item) => ({
                  ...item,
                  WorkTypeId: item.WorkType.Id
                })),
                TimesheetPerDiem: section.TimesheetPerDiem,
                Attachments: attachmentIndices
              };
            })
        };

        formData.append('Payload', JSON.stringify(payload));

        timesheet?.GlobalFiles?.forEach((fileObj) => {
          formData.append('Documents', fileObj.File);
        });

        await tneAxiosClient.post('v1/timesheet/sections/upsert', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        await dispatch(getTimesheet(params?.id, timesheet.UserId));
        await dispatch(setSaveSuccess(true));
      } else {
        await tneAxiosClient.put(`v1/timesheet?Id=${timesheet.Id}`, {
          ...timesheet,
          TimesheetStatus: timesheetsStatuses(t).draft.apiStatus,
          TimesheetDetails: timesheet.TimesheetDetails.map((item) => ({
            ...item,
            WorkTypeId: item.WorkType.Id
          }))
        });
        await dispatch(setSaveSuccess(true));
      }

      dirtySectionIds.map((id) => {
        return dispatch(changeStatus(timesheetsStatuses(t).draft.apiStatus, id));
      });

      // ✅ Clear IndexedDB draft after successful server save
      await clearDraft(timesheet.Id);

      if (withPopUp) setOpenPop('saved');
    } catch (e) {
      console.log('error: ', e);
      basicErrorHandler(dispatch, e?.response?.data);
    }

    if (withPopUp) setSavaing(false);
    dispatch(setSaveSuccess(false));
  };

  const getApprovers = async (clientId) => {
    dispatch(getListOfApprovers(clientId));
  };

  useEffect(() => {
  }, [dirtySectionIds])

  const sectionHandler = () => {
    setHasChanges(true);
    dispatch(addNewSection());
    setExpanded(`panel${timesheet?.TimesheetSections?.length > 0 ? timesheet?.TimesheetSections?.length : 0}`);
  }

  useEffect(() => {
    if (isTimesheetSubmitSuccess) setOpenPop('submittedSuccessfully');
  }, [isTimesheetSubmitSuccess]);

  const submitHandler = async () => {
    const isSplitFlow = timesheet?.IsSplitApprovalFlow || false;

    const detailsToValidate = isSplitFlow
      ? timesheet.TimesheetSections.flatMap(section => section.TimesheetDetails)
      : timesheet.TimesheetDetails;

    if (!detailsToValidate.every((item) => item.Location)) {
      setError(t('dashboard.timesheet.validations.location'));
      return;
    }

    if (!detailsToValidate.every((item) => item.WorkType?.Id)) {
      setError(t('dashboard.timesheet.validations.worktype'));
      return;
    }

    if (isSplitFlow) {
      if (!timesheet.TimesheetSections.every((item) => item.ApproverId !== null)) {
        setError(t('dashboard.timesheet.validations.approver'));
        return;
      }

      const hasDuplicateApproverId = (items) => {
        const ids = items.map(i => i.ApproverId);
        return ids.length !== new Set(ids).size;
      };

      if (hasDuplicateApproverId(timesheet.TimesheetSections)) {
        setError(t('dashboard.timesheet.validations.duplicateApprover'));
        return;
      }
    }

    if (!isTimesheetValid(isSplitFlow)) return;

    if (isSplitFlow) {
      // ✅ SPLIT FLOW: handle offline here (approver already in section data)
      if (!isOnline) {
        await saveDraftOffline(timesheet);
        await queueSubmission(timesheet, null, true, null);
        setHasChanges(false);
        dispatch(
          setNotification({
            isAppStyled: true,
            message: 'Timesheet queued - will submit when back online',
            duration: 5000,
            type: appNotificationsTypes.SUCCESS,
            bottom: '147px'
          })
        );
        return;
      }

      // Online split flow (unchanged from original)
      const formData = new FormData();
      const payload = {
        UserId: timesheet.UserId,
        TimesheetId: timesheet.Id,
        TimesheetSections: timesheet.TimesheetSections
          .filter((section) => {
            const status = section.Id
              ? section?.Status?.Status
              : timesheetsStatuses(t).draft.apiStatus;
            return (
              status !== timesheetsStatuses(t).approved.apiStatus &&
              status !== timesheetsStatuses(t).processed.apiStatus
            );
          })
          .map((section) => {
            const attachmentIndices = timesheet?.GlobalFiles?.map(
              (fileObj, index) => (fileObj.SectionId === section.Id ? index : -1)
            ).filter((index) => index !== -1);
            const isNewSection = typeof section.Id === 'string';

            return {
              ApproverId: section.ApproverId,
              ...(!isNewSection ? { Id: section.Id } : {}),
              Approver: section.Approver,
              SectionStatus: timesheetsStatuses(t).submitted.apiStatus,
              TimesheetDetails: section.TimesheetDetails.map((item) => {
                const { Id, ...rest } = item;
                return {
                  ...rest,
                  WorkTypeId: item.WorkType.Id,
                  ...(typeof Id === 'number' ? { Id } : {})
                };
              }),
              TimesheetPerDiem: section.TimesheetPerDiem,
              Attachments: attachmentIndices
            };
          })
      };

      formData.append('Payload', JSON.stringify(payload));
      timesheet?.GlobalFiles?.forEach((fileObj) => {
        formData.append('Documents', fileObj.File);
      });

      try {
        await tneAxiosClient.post('v1/timesheet/sections/upsert', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        await dispatch(getTimesheet(params?.id, timesheet.UserId));
        setHasChanges(false);
        await dispatch(setSubmitSuccess(true));
        setIsEdit(false);
        setOpenPop('submittedSuccessfully');
        setDirtySectionIds([]);
        await clearDraft(timesheet.Id);
      } catch (error) {
        console.log('error: ', error);
      }

      await dispatch(setSubmitSuccess(false));

    } else {
      // Both online AND offline need the approver from SubmitModal
      // finalSubmitTimesheet handles online vs offline after approver is selected
      setOpenPop('submit');
    }
  };

  const finalSubmitTimesheet = async (approver, cb) => {
    if (!isOnline) {
      try {
        await saveDraftOffline({ ...timesheet, ApproverId: approver });
        await queueSubmission(
          { ...timesheet, ApproverId: approver },
          approver,
          false,
          null
        );
        setHasChanges(false);
        dispatch(
          setNotification({
            isAppStyled: true,
            message: 'Timesheet queued - will submit when back online',
            duration: 5000,
            type: appNotificationsTypes.SUCCESS,
            bottom: '147px'
          })
        );
        cb(); // close the modal
      } catch (e) {
        basicErrorHandler(dispatch, e.message);
      }
      return;
    }

    // ✅ ONLINE: Normal submit (unchanged from original + clearDraft)
    try {
      await tneAxiosClient.put(`v1/timesheet?Id=${timesheet.Id}`, {
        ...timesheet,
        TimesheetStatus: timesheetsStatuses(t).submitted.apiStatus,
        ApproverId: approver,
        TimesheetDetails: timesheet.TimesheetDetails.map((item) => ({
          ...item,
          WorkTypeId: item.WorkType.Id
        }))
      });
      setHasChanges(false);
      dispatch(changeStatus(timesheetsStatuses(t).submitted.apiStatus));
      setIsEdit(false);
      await clearDraft(timesheet.Id);
      cb();
    } catch (e) {
      basicErrorHandler(dispatch, e.message);
    }
  };

  const deleteHandler = async () => {
    setOpenPop('deleteTS');
  };

  const deleteSectionHandler = async (sectionId) => {
    setOpenPop('deleteSection');
    setHasChanges(true);
    setSectionToDelete(sectionId);
  }

  const attachmentHandler = (section) => {
    if (timesheet?.IsSplitApprovalFlow) {
      dispatch(setSelectedSectionData(section));
    } else {
      setOpenPop('attachments')
    }
    setHasChanges(true);
  }

  const finalDeleteSection = () => {
    dispatch(deleteSection(sectionToDelete));
    setOpenPop(false);
    setSectionToDelete(null);
  };

  const placementHandler = () => {
    setOpenPop('placement');
  };

  const finalDeleteTSHandler = () => {
    dispatch(deleteTimesheet(timesheet.Id));
  };

  const copyHandler = () => {
    setOpenPop('copy');
  };

  const saveCommentHandler = (comment, commentId = '') => {
    if (commentId) {
      dispatch(updateComment(comment, commentId, timesheet?.IsSplitApprovalFlow, timesheet?.TimesheetSections?.[0]?.Id));
    } else {
      dispatch(saveComment(comment, timesheet.Id, timesheet?.IsSplitApprovalFlow, timesheet?.TimesheetSections?.[0]?.Id));
    }
  };

  const deleteCommentCB = (deletedComment) => {
    setOpenPop(false);
    dispatch(
      setNotification({
        isAppStyled: true,
        message: `1 ${t('common.general.deleted')}`,
        duration: 3000,
        type: appNotificationsTypes.SUCCESS,
        action: (
          <p
            role="presentation"
            className={classes.undoBtn}
            onClick={() => {
              saveCommentHandler(deletedComment.Reason);
              dispatch(removeNotification());
            }}
          >
            {t('common.general.undo')}
          </p>
        )
      })
    );
  };

  const deleteCommentHandler = (commentId) => {
    const rejectionReasons = timesheet?.IsSplitApprovalFlow
      ? timesheet?.TimesheetSections?.[0]?.TimesheetRejectionReasons
      : timesheet?.TimesheetRejectionReasons;

    const deletingComment = (rejectionReasons || []).find((comment) => comment.Id === commentId);
    setCommentToDelete(deletingComment);
    if (size.width > responsiveSizeTimesheet) {
      dispatch(deleteRejectionComment(commentId, timesheet?.TimesheetSections?.[0]?.Id, timesheet?.IsSplitApprovalFlow, () => deleteCommentCB(deletingComment)));
    } else {
      setOpenPop('deleteComment');
    }
  };

  const finalDeleteComment = () => {
    dispatch(deleteRejectionComment(commentToDelete.Id, timesheet?.TimesheetSections?.[0]?.Id, timesheet?.IsSplitApprovalFlow, () => deleteCommentCB(commentToDelete)));
  };

  const finalRejectTimesheet = async () => {
    try {
      setRejecting(true);
      if (timesheet?.IsSplitApprovalFlow) {
        await tneAxiosClient.post(`v1/timesheet/section/action-by-approver`, {
          TimesheetId: timesheet.Id,
          TimesheetSectionId: timesheet?.TimesheetSections[0].Id,
          Status: timesheetsStatuses(t).rejected.apiStatus,
          Reason: timesheet?.TimesheetRejectionReasons
        });
      } else {
        await tneAxiosClient.post(`v1/action-by-approver`, {
          TimesheetId: timesheet.Id,
          Status: timesheetsStatuses(t).rejected.apiStatus
        });
      }
      dispatch(changeStatus(timesheetsStatuses(t).rejected.apiStatus));
      setOpenPop('rejected');
    } catch (e) {
      basicErrorHandler(dispatch, e.message);
    }
    setRejecting(false);
  };

  const rejectHandler = () => {
    const timeData = timesheet?.IsSplitApprovalFlow
      ? timesheet?.TimesheetSections?.[0]?.TimesheetRejectionReasons
      : timesheet?.TimesheetRejectionReasons;
    if ((timeData || []).every((comment) => comment.ActionTaken !== 'Pending')) {
      setOpenPop('reject');
      return;
    }
    finalRejectTimesheet();
  };

  const checkIsRejectActive = () => {
    const reasons = timesheet?.IsSplitApprovalFlow
      ? timesheet?.TimesheetSections?.[0]?.TimesheetRejectionReasons
      : timesheet?.TimesheetRejectionReasons;
    return !(reasons || []).every((comment) => comment.ActionTaken !== 'Pending');
  };

  const approveHandler = () => {
    setOpenPop('approve');
  };

  const finalApproveTimesheet = async () => {
    try {
      setApproving(true);
      if (timesheet?.IsSplitApprovalFlow) {
        await tneAxiosClient.post(`v1/timesheet/section/action-by-approver`, {
          TimesheetId: timesheet.Id,
          TimesheetSectionId: timesheet?.TimesheetSections[0].Id,
          Status: timesheetsStatuses(t).approved.apiStatus,
          Reason: ''
        });
      } else {
        await tneAxiosClient.post(`v1/action-by-approver`, {
          TimesheetId: timesheet.Id,
          Status: timesheetsStatuses(t).approved.apiStatus,
          Reason: ''
        });
      }
      dispatch(changeStatus(timesheetsStatuses(t).approved.apiStatus));
      setOpenPop('approved');
    } catch (e) {
      basicErrorHandler(dispatch, e.message);
    }
    setApproving(false);
  };

  const deleteLine = () => {
    const { id, sectionId } = lineToDelete;
    const isSplit = timesheet?.IsSplitApprovalFlow;

    let deletedLine;
    let sectionDetails;

    if (isSplit) {
      const section = timesheet.TimesheetSections.find((sec) => sec.Id === sectionId);
      sectionDetails = section?.TimesheetDetails || [];
      deletedLine = sectionDetails.find((item) => item.Id === id);
    } else {
      sectionDetails = timesheet?.TimesheetDetails || [];
      deletedLine = sectionDetails.find((item) => item.Id === id);
    }

    if (sectionDetails.length === 1) {
      dispatch(addNewTimesheet(sectionId, isSplit));
    }

    dispatch(deleteLineById({ id, sectionId, isSplitApprovalFlow: isSplit }));

    dispatch(
      setNotification({
        isAppStyled: true,
        message: `1 ${t('common.general.deleted')}`,
        duration: 3000,
        type: appNotificationsTypes.SUCCESS,
        action: (
          <p
            role="presentation"
            className={classes.undoBtn}
            onClick={() => {
              dispatch(restoreDeletedTimesheetLine(deletedLine));
              dispatch(removeNotification());
            }}
          >
            {t('common.general.undo')}
          </p>
        )
      })
    );

    setHasChanges(true);
    setOpenPop('');
    setLineToDelete('');
  };

  const getCalendarType = (calType) => {
    if (calType < 8) return submissionEnum.WEEKLY;
    if (calType > 16) return submissionEnum.MONTHLY;
    return submissionEnum.BI_MONTHLY;
  };

  const getSubmissionType = async (clientId) => {
    const response = await tneAxiosClient.get(`v1/placement/${clientId}`);

    if (response) {
      if (response?.data?.Data?.length === 0) {
        if (isApprover) {
          setRateType(timesheet?.RateType?.toLowerCase() || rateEnum.HOURLY);
        }
        const details = timesheet?.IsSplitApprovalFlow
          ? timesheet.TimesheetSections?.[0]?.TimesheetDetails?.[0]
          : timesheet.TimesheetDetails?.[0];
        setSubmissionType(getCalendarType(details?.TimesheetHoursByDates?.length || 0));
        return;
      }
      if (isApprover) {
        setRateType(timesheet?.RateType?.toLowerCase() || rateEnum.HOURLY);
      }
      const placement = response.data.Data.find((item) => item.Id === timesheet.PlacementId);
      if (placement) {
        setSubmissionType(placement.Frequency.toLowerCase());
        setRateType(placement.RateType.toLowerCase());
        setIsSplitApprovalFlow(placement.IsSplitApprovalFlow);
      }
    }
  };

  const withdrawHandler = () => {
    setOpenPop('withdraw');
  };

  const finalWithdrawTimesheet = async () => {
    try {
      setWithdrawing(true);
      if (timesheet?.IsSplitApprovalFlow) {
        await tneAxiosClient.post(`v1/timesheet/section/action-by-approver`, {
          TimesheetId: timesheet.Id,
          TimesheetSectionId: timesheet?.TimesheetSections[0].Id,
          Status: timesheetsStatuses(t).submitted.apiStatus,
          Reason: ''
        });
      } else {
        await tneAxiosClient.post(`v1/action-by-approver`, {
          TimesheetId: timesheet.Id,
          Status: timesheetsStatuses(t).submitted.apiStatus,
          Reason: ''
        });
      }
      dispatch(changeStatus(timesheetsStatuses(t).submitted.apiStatus));
      setOpenPop('');
      dispatch(
        setNotification({
          isAppStyled: true,
          message: t('dashboard.tnecommon.withdrawsuccessmsg'),
          duration: 3000,
          bottom: '147px',
          type: appNotificationsTypes.SUCCESS,
          action: (
            <p
              role="presentation"
              className={classes.undoBtn}
              onClick={() => {
                dispatch(removeNotification());
                finalApproveTimesheet();
              }}
            >
              {t('common.general.undo')}
            </p>
          )
        })
      );
    } catch (e) {
      basicErrorHandler(dispatch, e.message);
    }
    setWithdrawing(false);
  };

  const renderModalContent = () => {
    switch (openPopUp) {
      case 'saved':
        return (
          <TimeandExpensePopup
            title={t('dashboard.timesheet.savedmessage')}
            primaryButton={{
              text: t('dashboard.timesheets.newbuttontxt'),
              action: () => navigate('/dashboard/create-timesheet')
            }}
            secondaryButton={{
              text: t('dashboard.timesheet.gotodashboard'),
              action: () => navigate('/dashboard/timesheets')
            }}
          />
        );
      case 'unsavedChanges':
        return (
          <UnsavedChanges
            saveHandler={saveHandler}
            closeHandler={() => setOpenPop(false)}
            rejectPreventing={setHasChanges}
          />
        )
      case 'delete':
        return (
          <DeletePopUp
            deleteHandler={() => deleteLine(lineToDelete)}
            closeHandler={() => {
              setOpenPop(false);
              setLineToDelete('');
            }}
            submissionType={submissionType}
          />
        )
      case 'deleteSection':
        return (
          <DeletePopUp
            deleteHandler={finalDeleteSection}
            closeHandler={() => {
              setOpenPop(false);
            }}
            pending={deletePending}
          />
        )
      case 'deleteTS':
        return (
          <DeletePopUp
            deleteHandler={finalDeleteTSHandler}
            closeHandler={() => {
              setOpenPop(false);
            }}
            pending={deletePending}
          />
        )
      case 'deleteComment':
        return (
          <DeletePopUp
            deleteHandler={finalDeleteComment}
            closeHandler={() => {
              setCommentToDelete(null);
              setOpenPop(false);
            }}
            pending={commentsaving}
          />
        )
      case 'submit':
        return <SubmitModal submitHandler={finalSubmitTimesheet} approvers={approvers} Id={timesheet.Id} />
      case 'requestNewApprover':
        return <SubmitModal Id={timesheet.Id} stepType="requestNewApprover" />
      case 'submittedSuccessfully':
        return <SubmitModal stepType="submittedSuccessfully" />
      case 'submittedSuccessfullyNew':
        return <SubmittedSuccessfull afterRequestNewApprover />
      case 'approved':
        return <FinalModal queryParams={locationQueryParams.search} message={t('dashboard.timesheet.approvedsuccessfully')} />
      case 'approve':
        return (
          <TimeandExpensePopup
            title={t('dashboard.timesheet.approveconfirmation')}
            primaryButton={{
              text: t('common.general.approve'),
              action: finalApproveTimesheet
            }}
            pending={approving}
          />
        )
      case 'rejected':
        return <FinalModal message={t('dashboard.timesheet.rejectedsuccessfully')} queryParams={locationQueryParams.search} />

      case 'reject':
        return <RejectModal />
      case 'copy':
        return <CopyModal timesheet={timesheet} withExternalRedirect />
      case 'withdraw':
        return <WithdrawModal confirm={finalWithdrawTimesheet} pending={withdrawing} />
      case 'attachments':
        return <div className="px-5 py-5 flex flex-col gap-5">
          <p className="text-navy-blue text-2xl font-medium">{t('dashboard.tnecommon.attachments')}</p>
          <Attachments
            status={timesheet?.IsSplitApprovalFlow ? selectedSectionData?.Status?.Status : timesheet?.Status?.Status}
            editeMode={isEdit}
            timesheetId={params?.id}
            attachments={timesheet?.IsSplitApprovalFlow ? selectedSectionData?.TimesheetAttachments : timesheet?.TimesheetAttachments}
            handleChanges={setHasChanges}
            sectionId={timesheet?.IsSplitApprovalFlow ? selectedSectionData?.Id : null}
            saveHandler={saveHandler}
            saving={saving}
            closeModal={() => setOpenPop('')}
          />
        </div>
      default:
        return null;
    }
  }

  useEffect(() => {
    if (selectedSectionData) setOpenPop('attachments')
  }, [selectedSectionData])

  function alertUser(event) {
    if (!hasChanges) return;
    event.preventDefault();
    // eslint-disable-next-line no-return-assign,consistent-return
    return (event.returnValue = '');
  }

  useEffect(() => {
    if (prevPendingDelete && !deletePending) {
      navigate('/dashboard/timesheets', { state: { idToDelete: timesheet.Id } });
    }
  }, [prevPendingDelete, deletePending]);

  useEffect(() => {
    if (timesheet?.ClientCompanyId) {
      getSubmissionType(timesheet.ClientCompanyId);
      getApprovers(timesheet.ClientCompanyId);
    }
  }, [timesheet?.Id, timesheet?.ClientCompanyId, timesheet?.PlacementId]);

  useEffect(() => {
    const checkForLocalDraft = async () => {
      if (!timesheet?.Id) return;

      const draft = await loadDraft(timesheet.Id);
      if (draft && draft.updatedAt > timesheet?.UpdatedDate) {
        console.log('Local draft is newer than server version');
        // Optionally prompt user to restore draft
      }
    };

    checkForLocalDraft();
  }, [timesheet?.Id]);

  useEffect(() => {
    if (timesheet && !previousTimesheet) {
      const details = timesheet?.IsSplitApprovalFlow
        ? timesheet?.TimesheetSections?.[0]?.TimesheetDetails?.[0]
        : timesheet?.TimesheetDetails?.[0];

      setStartDateOfPeriod(details?.TimesheetHoursByDates?.[0]?.Day);

      const dayItem = details?.TimesheetHoursByDates?.find((item) => {
        const date = new Date(item?.Day).getDate();
        return date === 1 || date === 16;
      });
      if (dayItem) {
        setCurrentMonth(new Date(dayItem.Day).getMonth());
      }
    }
  }, [timesheet]);

  useEffect(() => {
    const id = setInterval(async () => {
      if (isEdit && hasChanges && timesheet) {
        // Always save to IndexedDB (works offline)
        await saveDraftOffline(timesheet);

        // Also save to server if online
        if (isOnline) {
          saveHandler(false);
        }
      }
    }, 30000); // Changed from 120000 to 30 seconds
    return () => clearInterval(id);
  }, [isEdit, hasChanges, timesheet, isOnline, saveDraftOffline]);

  const closeHandler = () => {
    navigate(`/dashboard/timesheets${locationQueryParams.search}`);
  };

  useEffect(() => {
    window.addEventListener('beforeunload', alertUser);
    return () => {
      window.removeEventListener('beforeunload', alertUser);
    };
  }, [hasChanges]);

  useEffect(() => {
    return () => {
      if (hasChanges) setOpenPop('unsavedChanges');
    };
  }, []);

  useEffect(() => {
    if (lineToDelete) setOpenPop('delete');
  }, [lineToDelete]);

  useEffect(() => {
    const approverModal = searchParams.get('approver');
    const isOnlySubmitted = timesheet.Status.Status === timesheetsStatuses(t).submitted.apiStatus;
    if (approverModal === 'true' && isOnlySubmitted) {
      approveHandler();
    }
  }, [searchParams]);

  useEffect(() => {
    if (!isApprover && size.width < responsiveSizeTimesheet) setIsEdit(size.width < responsiveSizeTimesheet);
  }, [size.width]);

  useEffect(() => {
    const editMode = searchParams.get('editMode');
    const hasChangesMode = searchParams.get('hasChangesMode');
    const flag = searchParams.get('flag');

    if (flag === 'created') {
      setCreated(true);
      dispatch(
        setNotification({
          isAppStyled: true,
          message: `${t('dashboard.timesheet.timesheet')} ${t('common.general.created').toLowerCase()}`,
          duration: 3000,
          bottom: '147px',
          type: appNotificationsTypes.SUCCESS
        })
      );

      setSearchParams({
        ...getSerializedSearchParams(),
        flag: ''
      });
    }

    if (
      (editMode === 'true' && timesheet?.Status?.Status === timesheetsStatuses(t).draft.apiStatus) ||
      ([timesheetsStatuses(t).draft.apiStatus, timesheetsStatuses(t).rejected.apiStatus].includes(
        timesheet?.Status?.Status
      ) &&
        !isApprover)
    ) {
      setIsEdit(true);
    }
    if (hasChangesMode === 'true') setHasChanges(true);
  }, [searchParams]);

  const scrollLeftRight = (direction) => {
    if (!scrollableRef?.current || !scrollablePerDiem?.current) return;
    if (direction === 'left') {
      scrollableRef.current.scrollLeft -= 17.1;
      scrollablePerDiem.current.scrollLeft -= 17.1;
    } else {
      scrollableRef.current.scrollLeft += 17.1;
      scrollablePerDiem.current.scrollLeft += 17.1;
    }
  };

  const scrollByArrowsKeys = (e) => {
    if (e.key === 'ArrowRight') {
      if (scroll >= 100) return;
      scrollLeftRight('right');
      setScroll(scroll + (submissionType === submissionEnum.MONTHLY ? 1.2 : 4));
    }

    if (e.key === 'ArrowLeft') {
      if (scroll <= 0) return;
      scrollLeftRight('left');
      setScroll(scroll - (submissionType === submissionEnum.MONTHLY ? 1.2 : 4));
    }
  };

  const scrollByScroll = (e) => {
    if (size.width < responsiveSizeTimesheet) return;
    e.preventDefault();
    if (e.deltaY > 0) {
      if (scroll >= 100) return;
      scrollLeftRight('right');
      setScroll(scroll + (submissionType === submissionEnum.MONTHLY ? 2 : 4));
    }

    if (e.deltaY < 0) {
      if (scroll <= 0) return;
      scrollLeftRight('left');
      setScroll(scroll - (submissionType === submissionEnum.MONTHLY ? 2 : 4));
    }
  };

  const calculateScrollFromPosition = (scrollLeft) => {
    return Math.floor(
      (scrollLeft / scrollableRef.current.scrollWidth) * ((submissionType === submissionEnum.BI_MONTHLY || submissionType === submissionEnum.BI_WEEKLY) ? 200 : 150)
    );
  };

  useEffect(() => {
    window.addEventListener('keydown', scrollByArrowsKeys);

    if (scroll === 100 && scrollableRef?.current && scrollablePerDiem?.current) {
      scrollableRef.current.scrollLeft += scrollableRef.current.children[0].scrollWidth;
      scrollablePerDiem.current.scrollLeft += scrollableRef.current.children[0].scrollWidth;
    }
    if (scroll === 0 && scrollableRef?.current && scrollablePerDiem?.current) {
      scrollableRef.current.scrollLeft = 0;
      scrollablePerDiem.current.scrollLeft = 0;
    }

    return () => {
      window.removeEventListener('keydown', scrollByArrowsKeys);
    };
  }, [scrollableRef, scrollablePerDiem, scroll]);

  useEffect(() => {
    const handleTabKey = (e) => {
      if (e.key === 'Tab') {
        const tableScrollLeft = scrollableRef.current.scrollLeft;

        const newScrollValue = calculateScrollFromPosition(tableScrollLeft);
        setScroll(newScrollValue);
      }
    };

    window.addEventListener('keydown', handleTabKey);

    return () => {
      window.removeEventListener('keydown', handleTabKey);
    };
  }, [scrollableRef, scrollablePerDiem]);

  const contextValue = useMemo(
    () => ({ isEdit, setIsEdit, timesheet, hasChanges, setHasChanges }),
    [isEdit, setIsEdit, timesheet, hasChanges, setHasChanges]
  );

  const timesheetPeriodLabel = useMemo(() => {
    const details = timesheet?.TimesheetDetails?.[0];
    const days = details?.TimesheetHoursByDates;

    if (!days || !days.length || !submissionType) return '';

    const startDay = dayjs(days[0].Day);
    const endDay = dayjs(days.at(-1).Day);
    const isBiWeekly = submissionType === submissionEnum.BI_WEEKLY || submissionType === submissionEnum.BI_MONTHLY;
    const isMonthly = submissionType === submissionEnum.MONTHLY;

    if (isMonthly) return months(t)[startDay.get('month')];
    if (isBiWeekly) {
      return startDay.isSame(endDay, 'month')
        ? `${startDay.format('MMMM')} (${startDay.format('D')}-${endDay.format('D')})`
        : `${startDay.format('D MMM')} - ${endDay.format('D MMM')}`;
    }

    return `${startDay.format('D MMM')} - ${endDay.format('D MMM')}`;
  }, [timesheet?.TimesheetDetails, submissionType, t]);

  const totalSectionData = timesheet?.IsSplitApprovalFlow
    ? timesheet?.TimesheetSections?.flatMap(section => section.TimesheetDetails || []) || []
    : timesheet?.TimesheetDetails || [];

  return (
    <EditContext.Provider value={contextValue}>
      <section className={classes.mainContainer}>
        <Box sx={{ px: 2, pt: 1 }}>
          <TimesheetOfflineBanner context="detail" />
        </Box>
        {(size.width > responsiveSizeTimesheet) && (
          <div className={classes.closeContainer}>
            <button aria-label="Close" onClick={closeHandler}>
              <CloseIcon sx={{ cursor: 'pointer' }} />
            </button>
          </div>
        )}
        {(size.width > responsiveSizeTimesheet) && (
          <TimesheetsHeader
            timesheet={timesheet}
            submissionType={submissionType}
            isApprover={isApprover}
            created={created}
          />
        )}
        {workTypes && (
          <TimesheetTableWrapper
            data={timesheet?.IsSplitApprovalFlow ? timesheet?.TimesheetSections[0]?.TimesheetDetails : timesheet?.TimesheetDetails}
            submissionType={submissionType}
            saving={saving}
            rejecting={rejecting}
            save={saveHandler}
            submit={submitHandler}
            approve={approveHandler}
            reject={rejectHandler}
            withdraw={withdrawHandler}
            isRejectActive={checkIsRejectActive()}
            timesheetInfo={{
              status: timesheet.Status.Status,
              client: timesheet.ClientName,
              placement: timesheet.Placement,
              po: timesheet.PO,
              recordNo: timesheet.RecordNo,
              user: timesheet.User,
              type: timesheet.TimesheetType,
              created: timesheet.CreatedDate,
              sectionStatus: timesheet?.TimesheetSections?.[0]?.Status?.Status,
              isApprover: isApproverAccount
            }}
            currentMonth={currentMonth}
            placementStatus={timesheet.IsAssignmentCompletedForTimesheet}
            placementHandler={placementHandler}
            sectionHandler={sectionHandler}
            closeHandler={closeHandler}
            isSplitApprovalFlow={timesheet?.IsSplitApprovalFlow}
          >
            <MainTable
              scrollByScroll={scrollByScroll}
              markSectionDirty={markSectionDirty}
              timesheet={timesheet}
              data={timesheet?.TimesheetDetails || []}
              perdiems={timesheet?.TimesheetPerDiem || []}
              submissionType={submissionType}
              rateType={rateType}
              startDateOfPeriod={startDateOfPeriod}
              setStartDateOfPeriod={setStartDateOfPeriod}
              deleteLine={setLineToDelete}
              timesheetInfo={{
                status: timesheet.Status.Status,
                client: timesheet.ClientName,
                placement: timesheet.Placement,
                po: timesheet.PO,
                recordNo: timesheet.RecordNo,
                user: timesheet.User,
                type: timesheet.TimesheetType,
                created: timesheet.CreatedDate,
                isApprover
              }}
              setScroll={setScroll}
              setScrollableRef={setScrollableRef}
              setScrollablePerDiem={setScrollablePerDiem}
              scroll={scroll}
              created={created}
              placementStatus={timesheet.IsAssignmentCompletedForTimesheet}
              placementHandler={placementHandler}
              approvers={approvers}
              scrollableProps={{
                scrollableRef,
                scrollablePerDiem,
                scrollLeftRight,
              }}
              setOpenPop={setOpenPop}
              expansion={expanded}
              deleteHandler={deleteSectionHandler}
              sectionHandler={sectionHandler}
              attachmentHandler={attachmentHandler}
              copyHandler={copyHandler}
              saveCommentHandler={saveCommentHandler}
              deleteCommentHandler={deleteCommentHandler}
              commentsaving={commentsaving}
            />
          </TimesheetTableWrapper>
        )}
        <div className="flex flex-col gap-4 w-full">
          {timesheet?.IsSplitApprovalFlow ? (
            <DailyTotalHeatStrip
              data={timesheet?.TimesheetSections}
              submissionType={submissionType}
              workTypes={workTypes && baseWorkTypes ? [...workTypes, ...baseWorkTypes] : []}
              rateType={rateType}
            />
          ) : (
            workTypes && (
              <TotalSection
                data={totalSectionData}
                workTypes={workTypes && baseWorkTypes ? [...workTypes, ...baseWorkTypes] : []}
                rateType={rateType}
              />
            )
          )}
        </div>
        {timesheet.IsAssignmentCompletedForTimesheet &&
          size.width > responsiveSizeTimesheet &&
          (timesheet.Status.Status === timesheetsStatuses(t).draft.apiStatus ||
            timesheet.Status.Status === timesheetsStatuses(t).rejected.apiStatus) && (
            <div className={classes.placementStatus}>{t('dashboard.timesheet.placementStatus')}</div>
          )}
        {!(size.width > responsiveSizeTimesheet) && (
          <div className={`${classes.actions} bg-white shadow-2xl`}>
            <TimeandExpenseActions
              saving={saving}
              rejecting={rejecting}
              save={saveHandler}
              submit={submitHandler}
              approve={approveHandler}
              close={closeHandler}
              reject={rejectHandler}
              withdraw={withdrawHandler}
              isRejectActive={checkIsRejectActive()}
              submissionType={submissionType}
              isApprover={isApprover}
              status={timesheet.Status.Status}
              placementStatus={timesheet.IsAssignmentCompletedForTimesheet}
              placementHandler={placementHandler}
              isSplitApprovalFlow={isSplitApprovalFlow}
            />
          </div>
        )}
      </section>
      <BaseModal
        open={!!openPopUp}
        fullscreen={false}
        closeHandler={() => {
          if (timesheet?.IsSplitApprovalFlow && openPopUp === 'attachments') dispatch(setSelectedSectionData(null));
          setOpenPop('');
        }}
        title="&nbsp;"
        hideFooter
        hideHeader
        withSeparator={false}
        marginLeftRight={1}
        backgroundColor={openPopUp === 'copy' ? colors.PAGE_BACKGROUND : undefined}
        paperWidth={size.width > responsiveSizeTimesheet ? undefined : '100%'}
        paperStyles={
          size.width <= responsiveSizeTimesheet ? { margin: '15px', borderRadius: '10px' } : { borderRadius: '20px' }
        }
      >
        <WithCloseIcon close={() => {
          if (timesheet?.IsSplitApprovalFlow && openPopUp === 'attachments') dispatch(setSelectedSectionData(null));
          setOpenPop('')
        }} y={6}>
          {renderModalContent()}
        </WithCloseIcon>
      </BaseModal>
      {error && (
        <NotificationModal open={error} onClose={() => setError('')}>
          <p className={classes.errorMessage}>{error}</p>
        </NotificationModal>
      )}
    </EditContext.Provider>
  );
}